import { render, staticRenderFns } from "./updateVersionGrade.vue?vue&type=template&id=86c56d4e&scoped=true&"
import script from "./updateVersionGrade.vue?vue&type=script&lang=js&"
export * from "./updateVersionGrade.vue?vue&type=script&lang=js&"
import style0 from "./updateVersionGrade.vue?vue&type=style&index=0&id=86c56d4e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c56d4e",
  null
  
)

export default component.exports